import { render } from "./DonorFormCustomQuestions.vue?vue&type=template&id=35d61458"
import script from "./DonorFormCustomQuestions.vue?vue&type=script&lang=js"
export * from "./DonorFormCustomQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__